import PropTypes from "prop-types";
import FileField from "components/helpers/form/file-field";

function AudioField({id, onChange, name, value = null}) {
  return (
    <div className="input-group mb-3">
      <div className="input-group-prepend">
        <label className="input-group-text" htmlFor={id}>Audio</label>
      </div>
      <FileField id={id} name={name} onChange={onChange} value={value} />
      {value && value.includes("/") && (
        <div className="input-group-append">
          <a className="btn btn-secondary" href={value} rel="noreferrer" target="_blank">Play</a>
        </div>
      )}
    </div>
  );
}

AudioField.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string
};

export default AudioField;
